
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.state = $a5fd07fa01589658$var$Game.copyState(initialState);
        this.initialState = $a5fd07fa01589658$var$Game.copyState(initialState);
        this.score = 0;
        this.status = "idle";
    }
    static copyState(state) {
        return state.map((row)=>row.slice());
    }
    static moveRowLeft(row, game) {
        let filteredRow = row.filter((value)=>value !== 0);
        for(let i = 0; i < filteredRow.length - 1; i++)if (filteredRow[i] === filteredRow[i + 1]) {
            filteredRow[i] *= 2;
            filteredRow[i + 1] = 0;
            game.score += filteredRow[i];
            if (filteredRow[i] === 2048) game.status = "win";
        }
        filteredRow = filteredRow.filter((value)=>value !== 0);
        while(filteredRow.length < 4)filteredRow.push(0);
        return filteredRow;
    }
    move(direction) {
        if (this.status === "playing") {
            let changed = false;
            for(let i = 0; i < 4; i++){
                const original = [
                    ...this.state[i]
                ];
                const newRow = direction === "left" ? $a5fd07fa01589658$var$Game.moveRowLeft(original, this) : $a5fd07fa01589658$var$Game.moveRowRight(original, this);
                if (!changed && newRow.toString() !== original.toString()) changed = true;
                this.state[i] = newRow;
            }
            if (changed) {
                this.addRandomTile();
                if (!this.canMove()) this.status = "lose";
            }
        }
    }
    moveLeft() {
        this.move("left");
    }
    moveRight() {
        this.move("right");
    }
    static moveRowRight(row, game) {
        let filteredRow = row.filter((value)=>value !== 0);
        for(let i = filteredRow.length - 1; i > 0; i--)if (filteredRow[i] === filteredRow[i - 1]) {
            filteredRow[i] *= 2;
            filteredRow[i - 1] = 0;
            game.score += filteredRow[i];
            if (filteredRow[i] === 2048) game.status = "win";
        }
        filteredRow = filteredRow.filter((value)=>value !== 0);
        while(filteredRow.length < 4)filteredRow.unshift(0);
        return filteredRow;
    }
    canMove() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            const value = this.state[r][c];
            if (value === 0) return true;
            if (c < 3 && value === this.state[r][c + 1]) return true;
            if (r < 3 && value === this.state[r + 1][c]) return true;
        }
        return false;
    }
    static moveColumnUp(col, game) {
        let filteredColumn = col.filter((value)=>value !== 0);
        for(let i = 0; i < filteredColumn.length - 1; i++)if (filteredColumn[i] === filteredColumn[i + 1]) {
            filteredColumn[i] *= 2;
            filteredColumn[i + 1] = 0;
            game.score += filteredColumn[i];
            if (filteredColumn[i] === 2048) game.status = "win";
        }
        filteredColumn = filteredColumn.filter((value)=>value !== 0);
        while(filteredColumn.length < 4)filteredColumn.push(0);
        return filteredColumn;
    }
    moveUp() {
        if (this.status === "playing") {
            let changed = false;
            for(let c = 0; c < 4; c++){
                const originalColumn = [
                    this.state[0][c],
                    this.state[1][c],
                    this.state[2][c],
                    this.state[3][c]
                ];
                const newColumn = $a5fd07fa01589658$var$Game.moveColumnUp(originalColumn, this);
                if (!changed && newColumn.toString() !== originalColumn.toString()) changed = true;
                for(let r = 0; r < 4; r++)this.state[r][c] = newColumn[r];
            }
            if (changed) {
                this.addRandomTile();
                if (!this.canMove()) this.status = "lose";
            }
        }
    }
    static moveColumnDown(col, game) {
        let filteredColumn = col.filter((value)=>value !== 0);
        for(let i = filteredColumn.length - 1; i > 0; i--)if (filteredColumn[i] === filteredColumn[i - 1]) {
            filteredColumn[i] *= 2;
            filteredColumn[i - 1] = 0;
            game.score += filteredColumn[i];
            if (filteredColumn[i] === 2048) game.status = "win";
        }
        filteredColumn = filteredColumn.filter((value)=>value !== 0);
        while(filteredColumn.length < 4)filteredColumn.unshift(0);
        return filteredColumn;
    }
    moveDown() {
        if (this.status === "playing") {
            let changed = false;
            for(let c = 0; c < 4; c++){
                const originalColumn = [
                    this.state[0][c],
                    this.state[1][c],
                    this.state[2][c],
                    this.state[3][c]
                ];
                const newColumn = $a5fd07fa01589658$var$Game.moveColumnDown(originalColumn, this);
                if (!changed && newColumn.toString() !== originalColumn.toString()) changed = true;
                for(let r = 0; r < 4; r++)this.state[r][c] = newColumn[r];
            }
            if (changed) {
                this.addRandomTile();
                if (!this.canMove()) this.status = "lose";
            }
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return $a5fd07fa01589658$var$Game.copyState(this.state);
    }
    getStatus() {
        return this.status;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.state[r][c] === 0) emptyCells.push([
                r,
                c
            ]);
        }
        if (emptyCells.length > 0) {
            const randomIndex = Math.floor(Math.random() * emptyCells.length);
            const [row, col] = emptyCells[randomIndex];
            const newValue = Math.random() < 0.9 ? 2 : 4;
            this.state[row][col] = newValue;
        }
    }
    start() {
        this.score = 0;
        this.status = "playing";
        this.addRandomTile(2);
        this.addRandomTile(2);
    }
    restart() {
        this.state = $a5fd07fa01589658$var$Game.copyState(this.initialState);
        this.score = 0;
        this.status = "idle";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


"use strict";
const $09e991522ca7e64e$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($a5fd07fa01589658$exports)))();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$cells = Array.from(document.querySelectorAll(".field-cell"));
function $09e991522ca7e64e$var$renderGameBoard(state) {
    $09e991522ca7e64e$var$cells.forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        const value = state[row][col];
        cell.textContent = value !== 0 ? value : "";
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add(`field-cell--${value}`);
    });
}
const $09e991522ca7e64e$var$restartButton = document.createElement("button");
const $09e991522ca7e64e$var$controlPanel = document.querySelector(".controls");
$09e991522ca7e64e$var$restartButton.classList.add("button");
$09e991522ca7e64e$var$restartButton.classList.add("restart");
$09e991522ca7e64e$var$restartButton.textContent = "Restart";
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$startButton.remove();
    $09e991522ca7e64e$var$controlPanel.append($09e991522ca7e64e$var$restartButton);
    document.querySelector(".message-start").classList.add("hidden");
});
$09e991522ca7e64e$var$restartButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$restartButton.remove();
    $09e991522ca7e64e$var$controlPanel.append($09e991522ca7e64e$var$startButton);
    document.querySelector(".message-start").classList.remove("hidden");
    if (document.querySelector(".message-lose")) document.querySelector(".message-lose").classList.add("hidden");
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "ArrowRight") {
        $09e991522ca7e64e$var$game.moveRight();
        $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    }
    if (e.key === "ArrowLeft") {
        $09e991522ca7e64e$var$game.moveLeft();
        $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    }
    if (e.key === "ArrowUp") {
        $09e991522ca7e64e$var$game.moveUp();
        $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    }
    if (e.key === "ArrowDown") {
        $09e991522ca7e64e$var$game.moveDown();
        $09e991522ca7e64e$var$renderGameBoard($09e991522ca7e64e$var$game.getState());
    }
    const scorePoints = document.querySelector(".game-score");
    scorePoints.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getStatus() === "lose") document.querySelector(".message-lose").classList.remove("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "win") document.querySelector(".message-win").classList.remove("hidden");
});


//# sourceMappingURL=2048game.b75982bc.js.map
